<template>
  <div class="custom-container mx-auto">
    <TitleWrapper
      :filter-option="false"
      :title="dashboardHeading"
      tooltip-title="Dashboard"
      :display-breadcrumb="true"
    />
    <div class="bg-white rounded-xl mt-10">
      <CampusAttendanceGraph />
    </div>
    <div class="bg-white rounded-xl mt-10">
      <SectionAttendanceGraph />
    </div>
    <div class="bg-white rounded-xl mt-10">
      <PeriodAttendanceGraph />
    </div>
    <div class="bg-white rounded-xl mt-10">
      <TimetableGraph />
    </div>
    <div class="bg-white rounded-xl mt-10 px-5">
      <ExamsTable />
    </div>
    <div v-permission="FEE_MANAGER_PERMISSION" class="bg-white rounded-xl mt-10">
      <FeeManagerGraph />
    </div>
    <div v-permission="EXPENSE_PERMISSION" class="bg-white rounded-xl mt-10">
      <ExpenseGraph />
    </div>
    <div v-permission="EMAIL_AND_SMS_PERMISSION" class="bg-white rounded-xl mt-10">
      <EmailAndSmsGraph />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CampusAttendanceGraph from '@views/dashboard/DashboardGraphs/DashboardGraph/CampusAttendanceGraph.vue'
import SectionAttendanceGraph from '@views/dashboard/DashboardGraphs/DashboardGraph/SectionAttendanceGraph.vue'
import PeriodAttendanceGraph from '@views/dashboard/DashboardGraphs/DashboardGraph/PeriodAttendanceGraph.vue'
import TimetableGraph from '@views/dashboard/DashboardGraphs/DashboardGraph/TimetableGraph.vue'
import ExamsTable from '@src/router/views/dashboard/DashboardGraphs/DashboardGraph/ExamsTable.vue'
import FeeManagerGraph from '@views/dashboard/DashboardGraphs/DashboardGraph/FeeManagerGraph.vue'
import ExpenseGraph from '@views/dashboard/DashboardGraphs/DashboardGraph/ExpenseGraph.vue'
import EmailAndSmsGraph from '@views/dashboard/DashboardGraphs/DashboardGraph/EmailAndSmsGraph.vue'
import tooltipMixin from '@/src/mixins/components/tooltip-mixin.js'
import TitleWrapper from '@/src/components/TitleWrapper.vue'
import { ENV } from '@src/constants/general-constants.js'
export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: 'Dashboard' }],
  },
  components: {
    CampusAttendanceGraph,
    SectionAttendanceGraph,
    PeriodAttendanceGraph,
    TimetableGraph,
    FeeManagerGraph,
    ExpenseGraph,
    EmailAndSmsGraph,
    ExamsTable,
    TitleWrapper,
  },
  mixins: [tooltipMixin],
  data() {
    return {
      dashboard: 'dashboard',
      FEE_MANAGER_PERMISSION: {
        env: [ENV.DEV],
      },
      EXPENSE_PERMISSION: {
        env: [ENV.DEV],
      },
      EMAIL_AND_SMS_PERMISSION: {
        env: [ENV.DEV],
      },
    }
  },
  computed: {
    isAdmin() {
      return this.activeRole === 'super_admin'
    },
    dashboardHeading() {
      return this.currentSectionScope
        ? 'SECTION_DASHBOARD'
        : this.currentClassScope
        ? 'CLASS_DASHBOARD'
        : this.currentCampusScope
        ? 'CAMPUS_DASHBOARD'
        : 'INSTITUTE_DASHBOARD'
    },
    ...mapState('layout', [
      'activeRole',
      'currentCampusScope',
      'currentClassScope',
      'currentSectionScope',
    ]),
  },
  mounted() {
    if (this.isAdmin) this.$store.commit('layout/SET_APP_LOADING', false)
  },
  methods: {
    goToInstitueLevel() {
      this.$store.commit('layout/SET_SELECTED_CAMPUSE', '')
      this.$store.commit('layout/SET_CURRENT_SELECTED_SECTION_SCOPE', '')
    },
    redirectToCampusScope() {
      this.$store.commit('layout/SET_CURRENT_SELECTED_SECTION_SCOPE', '')
    },
  },
}
</script>
